import { BuildTranslationMap } from '../translationKeys'
import formLabels from './labels.json'
import formNotes from './notes.json'
import tableHeaders from './tableHeaders.json'

import enumTranslations from './enum.json'

export const translationDE = BuildTranslationMap(formLabels, formNotes, tableHeaders, enumTranslations)
